module.exports = __webpack_public_path__ + "static/media/analise-right.5f2b3281.png";